<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">

          <div class="col-12">
        
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Λίστα Τοποθεσιών</h3>

                <div class="card-tools">
                  
                  <button type="button" class="btn btn-sm btn-primary text-light" @click="newModal">
                      <i class="fa fa-plus-square"></i>
                      Προσθήκη Νέας
                  </button>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Ονομασία</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                     <tr v-for="place in places.data" :key="place.id">

                      <td>{{place.id}}</td>
                      <td>{{place.name}}</td>
                      <td>
                        
                        <a href="#" @click="editModal(place)">
                            <button class="bg-primary btn btn-sm" title="Επεξεργασία οχήματος">
                              <i class="fa fa-edit"></i>
                            </button>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <pagination :data="places" @pagination-change-page="getplaces"></pagination>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Δημιουργία Νέας Τοποθεσίας</h5>
                    <h5 class="modal-title" v-show="editmode">Επεξεργασία Τοποθεσίας</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form @submit.prevent="editmode ? updateplace() : createplace()">
                    <div class="modal-body">
                        <div class="form-group col-12 d-inline-block">
                            <v-text-field
                                label="Ονομασία"
                                v-model="form.name"
                                :class="{ 'is-invalid': form.errors.has('name') }"
                            ></v-text-field>
                            <has-error :form="form" field="plate"></has-error>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Κλείσιμο</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">Ενημέρωση</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Προσθήκη</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>

    export default {
        data () {
            return {
                editmode: false,
                places : {},
                form: new Form({
                    id : '',
                    plate: ''
                }),
                page: 1
            }
        },
        methods: {

          getplaces(page = 1) {

              //keep page to stay on the same page
              this.page = page;

              this.$Progress.start();
              
              axios.get('/api/places?page=' + page).then(({ data }) => (this.places = data.data));

              this.$Progress.finish();
          },
          loadplaces(){
              axios.get("/api/places").then(({ data }) => (this.places = data.data));
          },
          editModal(place){
              this.editmode = true;
              this.form.reset();
              $('#addNew').modal('show');
              this.form.fill(place);
          },
          newModal(){
              this.editmode = false;
              this.form.reset();
              $('#addNew').modal('show');
          },
          createplace(){
              this.$Progress.start();

              this.form.post('/api/places')
              .then((data)=>{
                if(data.data.success){
                  $('#addNew').modal('hide');

                  Toast.fire({
                        icon: 'success',
                        title: data.data.message
                    });
                  this.$Progress.finish();
                  this.loadplaces();

                } else {
                  Toast.fire({
                      icon: 'error',
                      title: 'Some error occured! Please try again'
                  });

                  this.$Progress.failed();
                }
              })
              .catch(()=>{

                  Toast.fire({
                      icon: 'error',
                      title: 'Some error occured! Please try again'
                  });
              })
          },
          updateplace(){
              this.$Progress.start();
              this.form.put('/api/places/'+this.form.id)
              .then((response) => {
                  // success
                  $('#addNew').modal('hide');
                  Toast.fire({
                    icon: 'success',
                    title: response.data.message
                  });
                  this.$Progress.finish();

                  
                  this.getplaces(this.page);
              })
              .catch(() => {
                  this.$Progress.fail();
              });

          },
        },
        mounted() {
            
        },
        created() {
            this.$Progress.start();

            this.loadplaces();

            this.$Progress.finish();
        },
        filters: {
            truncate: function (text, length, suffix) {
                return text.substring(0, length) + suffix;
            },
        },
        computed: {
          filteredItems() {
            return this.autocompleteItems.filter(i => {
              return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
            });
          },
        },
    }
</script>
